const state = {
  offersList: [],
  isHasMoreOffers: true,
  isHasMoreLenderOffers: true
};

const actions = {
  async getOffersList(context, status) {
    const list = await window.$httpService.offers.getOffersList(status);
    context.commit('setOffersList', list.data?.rows);

    if(list.data?.rows.length < 10) {
      context.commit('setHasMoreOffers', false);
    } else {
      context.commit('setHasMoreOffers', true);
    }
  },
  async updateOffersList(context, params) {
    const list = await window.$httpService.offers.updateOffersList(params);
    context.commit('updateOffersList', list.data?.rows);
    
    if(list.data?.rows.length < 10) {
      context.commit('setHasMoreOffers', false);
    } else {
      context.commit('setHasMoreOffers', true);
    }
  },
  async changeOfferStatus(context, data) {
    await window.$httpService.offers.changeOfferStatus(data);
  },
  async getLenderOffersList(context, params) {
    const list = await window.$httpService.offers.getLenderOffersList(params);
    context.commit('setOffersList', list.data?.rows);

    if(list.data?.rows.length < 10) {
      context.commit('setHasMoreLenderOffers', false);
    } else {
      context.commit('setHasMoreLenderOffers', true);
    }
  },
};

const mutations = {
  setOffersList(state, data) {
    state.offersList = data;
  },
  setHasMoreOffers(state, data) {
    state.isHasMoreOffers = data;
  },
  setHasMoreLenderOffers(state, data) {
    state.isHasMoreLenderOffers = data;
  },
  updateOffersList(state, data) {
    state.offersList = data;
  }
};

const getters = {
  offersList(state) {
    return state.offersList;
  },
  isHasMoreOffers(state) {
    return state.isHasMoreOffers;
  },
  isHasMoreLenderOffers(state) {
    return state.isHasMoreLenderOffers;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}